import React, { useEffect, useState } from 'react'
import { LandingPageImport } from '../Import'
const { Card, GitCommitHorizontal, ChevronLeft, ChevronRight, TextAnimate, Slider, useNavigate, useDispatch, useSelector, Loader, categoryList } = LandingPageImport

const NextArrow = ({ onClick }) => (
    <div className="custom-arrow next-arrow" onClick={onClick}>
        <ChevronRight size={30} />
    </div>
);

const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
        <ChevronLeft size={30} />
    </div>
);

export default function Categories() {

    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const category = useSelector(state => state?.categoryList?.data)

    var length = category?.length;
    var settings = {
        dots: false,
        infinite: length > 4,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: length > 4,
        autoplaySpeed: 1000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    useEffect(() => {
        setLoading(true)
        dispatch(categoryList({ navigate })).finally(() => setLoading(false))
    }, [])

    return (
        <>
            <div className="categories padding-100">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12">
                            <div className='hero_title'>
                                <h5 data-aos="fade-left" data-aos-duration="800">
                                    <GitCommitHorizontal className='ms-1 me-1' />
                                    15+ Events
                                </h5>
                            </div>

                            <div className="hero_sub_title">
                                <h2><TextAnimate text="Our Categories" /></h2>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="mt-5">
                                {loading ?
                                    <div className="layout">
                                        <Loader />
                                    </div>
                                    :
                                    category?.length ?
                                        <Slider {...settings}>
                                            {category?.map((val, index) => (
                                                <div key={index}>
                                                    <Card className='slider_card'>
                                                        <div className='hero_img slider_img'>
                                                            <Card.Img variant="top" src={process.env.REACT_APP_BASE_URL + val?.category_image} />
                                                            <Card.Title as={'h3'}>{val?.category_name}</Card.Title>
                                                        </div>
                                                    </Card>
                                                </div>
                                            ))}
                                        </Slider>
                                        :
                                        <div className='p-2 rounded d-flex justify-content-center align-items-center bg-body-secondary fw-medium'>
                                            No Categories Found
                                        </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
